import { interpretCompanyNameError, interpretUserNameError } from "./interpretators";
import { validators } from "./validators";

export const validateUser = (user) => {
    if(!user) {
        return ["errors.user_data_not_found"]
    }
    if (user["user-type"] === "legal") {
        return validateLegalUser(user);
    }
    if (user["user-type"] === "individual") {
        return validateIndividualUser(user);
    }
    return ["errors.user_data_not_found"]
};

export const validateLegalUser = (user) => {
    const errors = [];
    if (!user["person-full-name"]) {
        errors.push("errors.username.min_2");
    } else if (validators.ValidateUserName(user["person-full-name"])) {
        errors.push(interpretUserNameError(
            validators.ValidateUserName(user["person-full-name"])
        ));
    } else if (validators.ValidateLength(user["person-full-name"], 2, 100)) {
        errors.push("errors.username.max_100");
    }

    
    if (!user["company-name"]) {
        errors.push("errors.company_name.required");
    } else if (validators.ValidateCompanyName(user["company-name"])) {
        errors.push(
            interpretCompanyNameError(
                validators.ValidateCompanyName(user["company-name"])
            )
        )
    }

    if (!user["email"]) {
        errors.push("errors.email.required");
    } else if (validators.ValidateEmail(user["email"])) {
        errors.push("errors.email.invalid_format");
    }

    if (!user["phone-number"]) {
        errors.push("errors.phone.required");
    } else if (validators.ValidatePhone(user["phone-number"])) {
        errors.push("errors.phone.invalid_format");
    }

    if (!user["juridical-address"]) {
        errors.push("errors.juridical_address.required");
    }  else if (validators.ValidateLength(user["juridical-address"], 2)) {
        errors.push("errors.juridical_address.min_2");
    } else if (validators.ValidateLength(user["juridical-address"], 0, 300)) {
        errors.push("errors.juridical_address.max_300");
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(user["juridical-address"]))
    {
        errors.push("errors.juridical_address.only_english_letters")
    }

    if (!user["tax-department"]) {
        errors.push("errors.tax_department.required");
    } else if (validators.ValidateLength(user["tax-department"], 2)) {
        errors.push("errors.tax_department.min_2");
    } else if (validators.ValidateLength(user["tax-department"], 0, 30)) {
        errors.push("errors.tax_department.max_30");
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(user["tax-department"])) {
        errors.push("errors.tax_department.only_english_letters")
    }


    if (!user["tax-number"]) {
        errors.push("errors.tax_number.required");
    } else if (validators.ValidateNumber(user["tax-number"])) {
        errors.push("errors.tax_number.number");
    } else if (validators.ValidateLength(user["tax-number"], 2)) {
        errors.push("errors.tax_number.min_2");
    } else if (validators.ValidateLength(user["tax-number"], 0, 100)) {
        errors.push("errors.tax_number.max_100");
    }

    if (!user["person-post"]) {
        errors.push("errors.person_post.required");
    } else if (validators.ValidateLength(user["person-post"], 2)) {
        errors.push("errors.person_post.min_2");
    } else if (validators.ValidateLength(user["person-post"], 0, 100)) {
        errors.push("errors.person_post.max_100");
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(user["person-post"])) {
        errors.push("errors.person_post.only_english_letters")
    }
    
    return errors
}

export const validateIndividualUser = (user) => {
    let errors = [];
    
    // Full name
    if (!user["full-name"]) {
        errors.push("errors.username.min_2");
    } else if(validators.ValidateUserName(user["full-name"])) {
        errors.push(interpretUserNameError(
            validators.ValidateUserName(user["full-name"])
        ));
    }

    // Email
    if (!user["email"]) {
        errors.push("errors.email.required");
    } else if (validators.ValidateEmail(user["email"])) {
        errors.push("errors.email.invalid_format");
    }

    // Phone number
    if (!user["phone-number"]) {
        errors.push("errors.phone.required");
    } else if (validators.ValidatePhone(user["phone-number"])) {
        errors.push("errors.phone.invalid_format");
    }

    // Address
    if (!user["address"]) {
        errors.push("errors.user_address.required");
    } else if(validators.ValidateLength(user["address"], 2)) {
        errors.push("errors.user_address.min_2");
    } else if(validators.ValidateLength(user["address"], 0, 300)) {
        errors.push("errors.user_address.max_150");
    } else if(validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(user["address"])) {
        errors.push("errors.user_address.only_english_letters");
    }

    // Document type
    if (!user["identity-document-type"]) {
        errors.push("errors.identity_document_type.required");
    }

    // Document number
    if (!user["identity-document-number"]) {
        errors.push("errors.identity_document_number.required");
    } else if(validators.ValidateNumber(user["identity-document-number"], 2)) {
        errors.push("errors.identity_document_number.number");
    } else if(validators.ValidateLength(user["identity-document-number"], 2)) {
        errors.push("errors.identity_document_number.min_2");
    } else if(validators.ValidateLength(user["identity-document-number"], 0, 30)) {
        errors.push("errors.identity_document_number.max_30");
    }
    
    return errors
}